import { render } from "./WeekNavigator.vue?vue&type=template&id=717778bc&ts=true"
import script from "./WeekNavigator.ts?vue&type=script&lang=ts"
export * from "./WeekNavigator.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__